import { makeStyles } from '@material-ui/core'
import emoji from 'src/assets/Buy_Policy_Images/emoji.svg'
import add from 'src/assets/Buy_Policy_Images/add.svg'
import arrow from 'src/assets/Buy_Policy_Images/arrow.svg'
import infoPic from 'src/assets/Buy_Policy_Images/infoIcon.svg'
import { useHistory } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
} from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import {
  calculateAge,
  getISNPStatusRequestBody,
  getUpdatedUserDetails,
  isSelfRelation,
  isSelfRelationPresent,
} from 'src/utils/commonMethods/buyPolicy'
import {
  CURRENT_STATUS,
  ENCOUNTERED_ERROR_WHILE_SAVING,
  GENDER_LIST,
  INSURANCE_TYPE_CATOGORIES,
  MANDATORY_MEMBER_FIELDS,
  RELATION_TYPES,
} from 'src/utils/constants/BuyPolicy'
import { COLORS } from 'src/utils/Themes/colors'
import {
  showNotificationMessage,
  updateMemberDetails,
  updateNomineeDetails,
  updateProposerDetails,
  updateProviderDetails,
  updateUserDetails,
} from 'src/actions'
import LoadingModal from 'src/components/common/LoadingModal'
import ProposerDetailsForm from 'src/components/BuyPolicy/insuranceScreens/health/ProposerDetailsForm'
import {
  addScroll,
  isObjectEmpty,
  removeScroll,
  scrollToTop,
} from 'src/utils/commonMethods'
import { validateRequiredFormData } from 'src/services/formHelperService'
import IconButton from '@mui/material/IconButton'
import { Clear } from '@mui/icons-material'
import CustomDatePicker from 'src/components/BuyPolicy/common/CustomDatePicker'
import { getTokenForQrReport } from 'src/services/individualService'
import {
  fetchTokenForBuyPolicy,
  getProviderDetails,
  saveISNPStatus,
} from 'src/services/buyPolicyService'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import {
  ENCOUNTERED_ERROR_POCILY_DETAILS,
  PLEASE_FILL_REQ_DETAILS,
  RELATION,
} from 'src/utils/constants/Health'

const MemberDetailsForm = () => {
  const classes = useStyles()
  const history = useHistory()
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)
  const [loading, setLoading] = useState(false)
  const [memberDetails, setMemberDetails] = useState(
    guestUserDetails?.memberDetails
  )
  const [proposerDetails, setProposerDetails] = useState(
    guestUserDetails?.proposerDetails
  )
  const [nomineeDetails, setNomineeDetails] = useState(
    guestUserDetails?.nomineeDetails
  )
  const [formErrors, setFormErrors] = useState({})
  const providerDetails = guestUserDetails?.providerDetails
  useEffect(() => {
    scrollToTop()
    if (isObjectEmpty(providerDetails)) {
      fetchTokenAndProviderDetails()
    }
    setDefaultNomineeForSpouse()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setMemberDetails(guestUserDetails?.memberDetails)
    setProposerDetails(guestUserDetails?.proposerDetails)
  }, [guestUserDetails?.memberDetails, guestUserDetails?.proposerDetails])

  const fetchTokenAndProviderDetails = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)

      const token = response?.res?.data?.access_token
      fetchProviderDetails(token)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const fetchProviderDetails = async (token) => {
    setLoading(true)

    const response = await getProviderDetails(
      token,
      guestUserDetails?.selectedQuote?.providerId
    )
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        dispatch(updateProviderDetails(responseData?.data))
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ENCOUNTERED_ERROR_POCILY_DETAILS,
        })
      )
    }
  }

  const saveMetadataAndNavigate = () => {
    setLoading(true)

    fetchTokenForBuyPolicy()
      .then((token) => {
        setLoading(false)
        saveISNPStatusTasks(token)
      })
      .catch(() => {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
          })
        )
      })
  }

  const saveISNPStatusTasks = async (token) => {
    setLoading(true)
    const formData = getISNPStatusRequestBody(
      guestUserDetails,
      INSURANCE_TYPE_CATOGORIES?.health,
      CURRENT_STATUS?.detailsFilled
    )

    saveISNPStatus(token, formData)
      .then((response) => {
        return response?.res?.data
      })
      .then(() => {
        setLoading(false)
        history.push(
          '/individual/dashboard/buyPolicy/health/insuranceDetails/medical-condition'
        )
      })
      .catch(() => {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: ENCOUNTERED_ERROR_WHILE_SAVING,
          })
        )
      })
  }

  const dispatchEvents = () => {
    const updatedMembers = [...memberDetails]
    dispatch(updateProposerDetails(proposerDetails))
    dispatch(updateMemberDetails(updatedMembers))
    dispatch(updateNomineeDetails(nomineeDetails))
  }

  const handleBackToQuotesClick = () => {
    dispatchEvents()
    history.push('/individual/dashboard/buyPolicy/health/insuranceDetails')
  }

  const handleHealthDetails = async () => {
    const formData = {
      proposerDetails: JSON.parse(JSON.stringify(proposerDetails)),
      memberDetails: JSON.parse(JSON.stringify(memberDetails)),
      nomineeDetails: JSON.parse(JSON.stringify(nomineeDetails)),
    }

    delete formData?.proposerDetails?.medicalQuestionnaire
    formData.memberDetails = formData?.memberDetails?.filter(
      (member) => !isSelfRelation(member?.relation)
    )

    formData?.memberDetails?.forEach((member) => {
      delete member?.medicalQuestionnaire
    })

    const { errorKeys, isFormValid } = validateRequiredFormData(
      formData,
      MANDATORY_MEMBER_FIELDS
    )

    if (isFormValid) {
      setLoading(false)
      dispatch(
        updateUserDetails(
          getUpdatedUserDetails(
            proposerDetails,
            memberDetails,
            guestUserDetails?.userDetails
          )
        )
      )
      dispatchEvents()
      saveMetadataAndNavigate()
    } else {
      setFormErrors(errorKeys)
      setLoading(false)
      scrollToTop()
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: PLEASE_FILL_REQ_DETAILS,
        })
      )
    }
  }

  const getSubHeading = (relation) => {
    return (
      <>
        Insured Member&nbsp;&nbsp;
        <span className={classes.subHeadingRelation}>
          (&nbsp;{RELATION_TYPES?.[relation]}&nbsp;)
        </span>
      </>
    )
  }

  const dispatch = useDispatch()

  const handleInputChange = (event, index) => {
    const updatedMemberDetails = [...memberDetails]
    updatedMemberDetails[index][event?.target?.name] = event?.target?.value
    setMemberDetails(updatedMemberDetails)
  }

  const handleClear = (key, index) => {
    const updatedMemberDetails = [...memberDetails]
    updatedMemberDetails[index][key] = ''
    setMemberDetails(updatedMemberDetails)
  }

  const handleInputChangeForPointOfContact = (event) => {
    setNomineeDetails({
      ...nomineeDetails,
      [event?.target?.name]: event?.target?.value,
    })
  }

  const handleInputClearForPointOfContact = (key) => {
    setNomineeDetails({
      ...nomineeDetails,
      [key]: '',
    })
  }

  const handleNomineeSelect = (checked, index) => {
    const updatedMemberDetails = [...memberDetails]
    updatedMemberDetails?.forEach((member, arrayIndex) => {
      if (arrayIndex === index) {
        member['isNominee'] = checked
      } else {
        member['isNominee'] = false
      }
    })

    if (checked) {
      setNomineeDetails(updatedMemberDetails[index])
    } else {
      setNomineeDetails({
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        gender: '',
        relation: '',
      })
    }

    setMemberDetails(updatedMemberDetails)
  }

  const isErrorFormField = (fieldName, objectName, index = null) => {
    const formErrorObject = formErrors[objectName]
    if (formErrorObject) {
      let formError
      if (index !== null) {
        formError = formErrorObject?.[index]?.[fieldName]
      } else {
        formError = formErrorObject?.[fieldName]
      }
      if (formError) {
        return formError?.error
      }
    }

    return false
  }

  const errorFormFieldIndex = (index) => {
    return isSelfRelationPresent(memberDetails) ? index - 1 : index
  }

  const showNomineeCheckBox = (member) => {
    if (member?.dateOfBirth) {
      return calculateAge(member?.dateOfBirth) >= 18
    } else {
      return member?.age >= 18
    }
  }
  const setDefaultNomineeForSpouse = () => {
    const updatedMemberDetails = [...memberDetails]
    const spouseIndex = updatedMemberDetails?.findIndex(
      (member) => member?.relation === RELATION?.SPOUSE
    )

    if (spouseIndex !== -1) {
      updatedMemberDetails[spouseIndex].isNominee = true
      setNomineeDetails(updatedMemberDetails?.[spouseIndex])
    }

    setMemberDetails(updatedMemberDetails)
  }

  return (
    <>
      <LoadingModal loading={loading} />
      <form className={classes.formContainer}>
        <div
          onClick={handleBackToQuotesClick}
          className={classes.goBackButtonContainer}
        >
          <img src={arrow} alt='arrow' />
          <span className={classes.gotoBackButton}>Go back to Quotes</span>
        </div>
        <div className={classes.headingContainer}>
          <span className={classes.heading}>
            Great! Let&apos;s start with proposer details
          </span>
          <br />
          <span className={classes.headingDescription}>
            Proposer is going to pay the premium and avail tax benefits
          </span>
        </div>
        <div>
          <ProposerDetailsForm
            proposerDetails={proposerDetails}
            setProposerDetails={setProposerDetails}
            formErrors={formErrors.proposerDetails}
            providerDetails={providerDetails}
          />
          <div>
            {memberDetails?.map((member, index) => {
              return !isSelfRelation(member?.relation) ? (
                <div
                  key={`MemberDetailsForm_${member?.id}`}
                  className={classes.backgroundContainer}
                >
                  <div className={classes.container}>
                    <div className={classes.subHeadingContainer}>
                      <span className={classes.subHeading}>
                        {getSubHeading(member?.relation)}
                      </span>
                      {showNomineeCheckBox(member) ? (
                        <div className={classes.checkboxContainer}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                id='nomineeCheck'
                                size='small'
                                checked={member?.isNominee}
                                onChange={(e) =>
                                  handleNomineeSelect(e?.target?.checked, index)
                                }
                              />
                            }
                            label='Select as my Nominee'
                          />
                        </div>
                      ) : null}
                    </div>
                    <div className={classes.inputContainer}>
                      <div className={classes.inputContent}>
                        <TextField
                          id='firstName'
                          name='firstName'
                          type='text'
                          placeholder='First Name *'
                          value={member?.firstName ?? ''}
                          required
                          error={isErrorFormField(
                            'firstName',
                            'memberDetails',
                            errorFormFieldIndex(index)
                          )}
                          helperText={
                            isErrorFormField(
                              'firstName',
                              'memberDetails',
                              errorFormFieldIndex(index)
                            )
                              ? 'Invalid First Name'
                              : ''
                          }
                          onChange={(event) => handleInputChange(event, index)}
                          className={`${classes.inputTextField} ${classes.firstNameField}`}
                        ></TextField>
                      </div>

                      <div className={classes.inputContent}>
                        <TextField
                          id='lastName'
                          name='lastName'
                          type='text'
                          placeholder='Last Name *'
                          value={member?.lastName ?? ''}
                          required
                          error={isErrorFormField(
                            'lastName',
                            'memberDetails',
                            errorFormFieldIndex(index)
                          )}
                          helperText={
                            isErrorFormField(
                              'lastName',
                              'memberDetails',
                              errorFormFieldIndex(index)
                            )
                              ? 'Invalid Last Name'
                              : ''
                          }
                          onChange={(event) => handleInputChange(event, index)}
                          className={`${classes.inputTextField} ${classes.firstNameField}`}
                        ></TextField>
                      </div>

                      <div className={classes.inputContent}>
                        <CustomDatePicker
                          id='dateOfBirth'
                          name='dateOfBirth'
                          placeholder='Date of birth *'
                          value={member?.dateOfBirth ?? ''}
                          error={isErrorFormField(
                            'dateOfBirth',
                            'memberDetails',
                            errorFormFieldIndex(index)
                          )}
                          helperText={
                            isErrorFormField(
                              'dateOfBirth',
                              'memberDetails',
                              errorFormFieldIndex(index)
                            )
                              ? 'Invalid Date of Birth'
                              : ''
                          }
                          onChange={(event) => handleInputChange(event, index)}
                          className={`${classes.inputTextField} ${classes.firstNameField}`}
                        ></CustomDatePicker>
                      </div>
                    </div>

                    <div className={classes.inputContainer}>
                      {member?.age > 18 ? (
                        <div className={classes.inputContent}>
                          <FormControl
                            fullWidth
                            className={classes.formContainerStyles}
                            error={isErrorFormField(
                              'profession',
                              'memberDetails',
                              errorFormFieldIndex(index)
                            )}
                          >
                            <Autocomplete
                              id='profession'
                              name='profession'
                              value={
                                providerDetails?.occupation?.find(
                                  (item) => item?.value === member?.profession
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                handleInputChange(
                                  {
                                    target: {
                                      name: 'profession',
                                      value: newValue?.value || '',
                                    },
                                  },
                                  index
                                )
                              }}
                              options={providerDetails?.occupation ?? []}
                              getOptionLabel={(option) => option?.label}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  id='profession'
                                  name='profession'
                                  placeholder='Occupation'
                                  className={classes.inputTextField}
                                  sx={{
                                    '& .MuiInputBase-root': {
                                      '& input': {
                                        height: '0.7rem !important',
                                        minHeight: 'unset',
                                      },
                                    },
                                    '& .MuiInputAdornment-root': {
                                      display: member?.profession ? '' : 'none',
                                    },
                                  }}
                                  endAdornment={
                                    member.profession && (
                                      <IconButton
                                        id='professionClear'
                                        className='clear-button'
                                        onClick={() =>
                                          handleClear('profession', index)
                                        }
                                      >
                                        <Clear />
                                      </IconButton>
                                    )
                                  }
                                />
                              )}
                              renderOption={(props, option) => (
                                <MenuItem
                                  {...props}
                                  key={option?.value}
                                  value={option}
                                >
                                  {option?.label}
                                </MenuItem>
                              )}
                            />
                            {isErrorFormField(
                              'profession',
                              'memberDetails',
                              errorFormFieldIndex(index)
                            ) && (
                              <FormHelperText>
                                Invalid Occupation
                              </FormHelperText>
                            )}
                          </FormControl>
                        </div>
                      ) : null}

                      <div className={classes.inputContent}>
                        <div className={classes.inputItem}>
                          <FormControl>
                            <RadioGroup
                              row
                              id='gender'
                              name='gender'
                              value={member.gender}
                              onChange={(event) => {
                                handleInputChange(event, index)
                              }}
                            >
                              {GENDER_LIST?.map((genderListItem) => {
                                return (
                                  <FormControlLabel
                                    key={`gender_${genderListItem?.label}`}
                                    value={genderListItem?.enum}
                                    control={<Radio />}
                                    label={genderListItem?.label}
                                    className={classes.formLabelFont}
                                  />
                                )
                              })}
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                      <div
                        className={`${classes.inputContent} ${classes.heightWeightContainer}`}
                      >
                        <TextField
                          id='height'
                          type='number'
                          name='height'
                          placeholder='Height *'
                          error={isErrorFormField(
                            'height',
                            'memberDetails',
                            errorFormFieldIndex(index)
                          )}
                          helperText={
                            isErrorFormField(
                              'height',
                              'memberDetails',
                              errorFormFieldIndex(index)
                            )
                              ? 'Invalid Height'
                              : ''
                          }
                          className={`${classes.inputTextField} ${classes.firstNameField}`}
                          value={member?.height ?? ''}
                          onChange={(event) => {
                            if (
                              event?.target?.value > 0 ||
                              event?.target?.value === ''
                            ) {
                              handleInputChange(event, index)
                            }
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position='end'>CM</InputAdornment>
                            ),
                          }}
                        ></TextField>

                        <TextField
                          id='weight'
                          type='number'
                          name='weight'
                          placeholder='Weight *'
                          error={isErrorFormField(
                            'weight',
                            'memberDetails',
                            errorFormFieldIndex(index)
                          )}
                          helperText={
                            isErrorFormField(
                              'weight',
                              'memberDetails',
                              errorFormFieldIndex(index)
                            )
                              ? 'Invalid Weight'
                              : ''
                          }
                          className={`${classes.inputTextField} ${classes.firstNameField}`}
                          value={member.weight ?? ''}
                          onChange={(event) => {
                            if (
                              event?.target?.value > 0 ||
                              event?.target?.value === ''
                            ) {
                              handleInputChange(event, index)
                            }
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position='end'>KG</InputAdornment>
                            ),
                          }}
                        ></TextField>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null
            })}
          </div>
        </div>

        <div className={classes.pocBackgroundContainer}>
          <div className={classes.container}>
            <div className={classes.insuredContent}>
              <div>
                <div className={classes.nomineeContainer}>
                  <span className={classes.pointOfContactSubHeading}>
                    Point of Nominee Details{' '}
                  </span>
                  <span>
                    <Tooltip
                      placement='bottom'
                      componentsProps={{
                        tooltip: {
                          sx: {
                            backgroundColor: `${COLORS.WHITE} !important`,
                            color: COLORS.GREY,
                            textAlign: 'center',
                            fontSize: '15px',
                            padding: '20px',
                            boxShadow: ' 10px 10px 30px  rgba(0, 0, 0, 0.7)',
                            borderRadius: '10px',
                          },
                        },
                        arrow: {
                          sx: {
                            color: `${COLORS.WHITE} !important`,
                          },
                        },
                      }}
                      title={
                        <>
                          <div>
                            In the event of the policyholder&apos;s untimely
                            demise during medical treatment, the nominees are
                            entitled to receive the pre-determined sum assured.
                          </div>
                        </>
                      }
                      arrow
                    >
                      <img
                        src={infoPic}
                        alt='infoIcon'
                        className={classes.infoIcon}
                      />
                    </Tooltip>
                  </span>
                </div>
                {nomineeDetails?.relation && (
                  <span className={classes.subHeadingItem}>
                    (You&apos;ve chosen your{' '}
                    {RELATION_TYPES[nomineeDetails?.relation]})
                  </span>
                )}
              </div>
            </div>
            <div className={classes.inputContainer}>
              <div className={classes.inputContent}>
                <TextField
                  id='firstName'
                  name='firstName'
                  type='text'
                  placeholder='First Name *'
                  error={isErrorFormField('firstName', 'nomineeDetails')}
                  helperText={
                    isErrorFormField('firstName', 'nomineeDetails')
                      ? 'Invalid First Name'
                      : ''
                  }
                  value={nomineeDetails?.firstName}
                  onChange={handleInputChangeForPointOfContact}
                  className={`${classes.inputTextField} ${classes.firstNameField}`}
                ></TextField>
              </div>

              <div className={classes.inputContent}>
                <TextField
                  id='lastName'
                  name='lastName'
                  type='text'
                  placeholder='Last Name *'
                  error={isErrorFormField('lastName', 'nomineeDetails')}
                  helperText={
                    isErrorFormField('lastName', 'nomineeDetails')
                      ? 'Invalid Last Name'
                      : ''
                  }
                  value={nomineeDetails?.lastName}
                  onChange={handleInputChangeForPointOfContact}
                  className={`${classes.inputTextField} ${classes.firstNameField}`}
                ></TextField>
              </div>

              <div className={classes.inputContent}>
                <CustomDatePicker
                  id='dateOfBirth'
                  name='dateOfBirth'
                  placeholder='Date of birth *'
                  error={isErrorFormField('dateOfBirth', 'nomineeDetails')}
                  helperText={
                    isErrorFormField('dateOfBirth', 'nomineeDetails')
                      ? 'Invalid Date of Birth'
                      : ''
                  }
                  value={nomineeDetails?.dateOfBirth}
                  onChange={handleInputChangeForPointOfContact}
                  className={`${classes.inputTextField} ${classes.firstNameField}`}
                ></CustomDatePicker>
              </div>
            </div>

            <div className={classes.inputContainer}>
              <div className={classes.inputContent}>
                <FormControl
                  fullWidth
                  className={classes.formContainerStyles}
                  error={isErrorFormField('relation', 'nomineeDetails')}
                >
                  <Select
                    id='relation'
                    name='relation'
                    placeholder={'Relation'}
                    displayEmpty
                    defaultValue=''
                    className={classes.inputTextField}
                    value={nomineeDetails?.relation}
                    onChange={handleInputChangeForPointOfContact}
                    sx={{
                      '&  .MuiSelect-select': {
                        height: '0.7rem !important',
                        minHeight: 'unset',
                      },
                      '& .MuiSelect-iconOutlined': {
                        display: nomineeDetails?.relation ? 'none' : '',
                      },
                    }}
                    endAdornment={
                      <IconButton
                        id='nomineeRelationClear'
                        sx={{ display: nomineeDetails?.relation ? '' : 'none' }}
                        className={'clear-button'}
                        onClick={() =>
                          handleInputClearForPointOfContact('relation')
                        }
                      >
                        <Clear />
                      </IconButton>
                    }
                    onOpen={() => {
                      removeScroll()
                    }}
                    onClose={() => {
                      addScroll()
                    }}
                  >
                    <MenuItem value={''} className={'default-menu-item'}>
                      Relation
                    </MenuItem>
                    {providerDetails?.nomineeRelationType?.map(
                      (relationListItem) => (
                        <MenuItem
                          key={relationListItem?.value}
                          value={relationListItem?.value}
                        >
                          {relationListItem?.label}
                        </MenuItem>
                      )
                    )}
                  </Select>
                  {isErrorFormField('relation', 'nomineeDetails') && (
                    <FormHelperText>Invalid Nominee Relation</FormHelperText>
                  )}
                </FormControl>
              </div>

              <div className={classes.inputContent}>
                <FormControl
                  fullWidth
                  className={classes.formContainerStyles}
                  error={isErrorFormField('gender', 'nomineeDetails')}
                >
                  <Select
                    id='gender'
                    name='gender'
                    placeholder={'Gender'}
                    displayEmpty
                    className={classes.inputTextField}
                    value={nomineeDetails?.gender ?? ''}
                    onChange={handleInputChangeForPointOfContact}
                    sx={{
                      '&  .MuiSelect-select': {
                        height: '0.7rem !important',
                        minHeight: 'unset',
                      },
                      '& .MuiSelect-iconOutlined': {
                        display: nomineeDetails?.gender ? 'none' : '',
                      },
                    }}
                    endAdornment={
                      <IconButton
                        id='nomineeGenderClear'
                        sx={{ display: nomineeDetails?.gender ? '' : 'none' }}
                        className={'clear-button'}
                        onClick={() =>
                          handleInputClearForPointOfContact('gender')
                        }
                      >
                        <Clear />
                      </IconButton>
                    }
                    onOpen={() => {
                      removeScroll()
                    }}
                    onClose={() => {
                      addScroll()
                    }}
                  >
                    <MenuItem value={''} className={'default-menu-item'}>
                      Gender
                    </MenuItem>
                    {GENDER_LIST?.map((option) => (
                      <MenuItem key={option?.enum} value={option?.enum}>
                        {option?.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {isErrorFormField('gender', 'nomineeDetails') && (
                    <FormHelperText>Invalid Nominee Gender</FormHelperText>
                  )}
                </FormControl>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.buttonContainer}>
          <div className={classes.almostImage}>
            <div className={classes.almostImageContent}>
              <img src={emoji} alt='smile emoji' />
            </div>
            <div>
              <span className={classes.almostContent}>You are almost</span>
              <span className={classes.almostDescription}>DONE</span>
            </div>
          </div>

          <div className={classes.healthDetailsContainer}>
            <div>
              <Button
                id='healthDetailButton'
                type={'button'}
                onClick={handleHealthDetails}
                className={classes.healthDetailDescription}
              >
                Enter Health Details
              </Button>
            </div>
            <div>
              <img src={add} alt='add' />
            </div>
          </div>
        </div>
      </form>
    </>
  )
}

export default MemberDetailsForm

const useStyles = makeStyles({
  formContainer: {
    width: '100%',
  },
  gotoBackButton: {
    fontSize: '12px',
    border: '1px',
    backgroundColor: 'white',
    cursor: 'pointer',
  },
  formLabelFont: {
    '& .MuiFormControlLabel-label': {
      fontSize: '12px',
    },
  },
  firstNameField: {
    '&  .MuiOutlinedInput-input': {
      height: '0.7rem',
    },
  },
  backgroundContainer: {
    background: 'linear-gradient(to bottom, #4DC3E3 , #FFFFFF )',
    padding: '1px',
    borderRadius: '10px',
    marginBottom: '20px',
  },
  container: {
    padding: '25px',
    borderRadius: '10px',
    // boxShadow: '0px 8px 8px 0px #0000001A',
    background: COLORS.WHITE,
  },
  pocBackgroundContainer: {
    background: 'linear-gradient(to bottom, #EF669B, #FFFFFF )',
    padding: '1px',
    borderRadius: '10px',
  },
  headingContainer: {
    marginBottom: '25px',
  },
  heading: {
    fontSize: '18px',
    fontWeight: '600',
  },
  headingDescription: {
    fontSize: '13px',
    lineHeight: '1.5',
    color: '#7C7C7C',
    fontWeight: '600',
  },
  subHeadingContainer: {
    marginBottom: '15px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  subHeading: {
    fontSize: '16px',
    color: '#29AACD',
    fontWeight: '600',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  subHeadingRelation: {
    fontSize: '16px',
    color: COLORS.BLACK,
  },
  pointOfContactSubHeading: {
    fontSize: '16px',
    color: '#EF669B',
    fontWeight: '600',
  },
  insuredTitle: {
    width: '50%',
  },
  listItems: {
    color: '#838383',
    marginLeft: '-20px',
  },
  inputContainer: {
    display: 'flex',
    marginBottom: '20px',
    gap: '25px',
  },
  inputContent: {
    width: 'calc(94% / 3)',
  },
  inputOtherContent: {
    width: '33%',
  },
  genderContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  textField: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    width: '90%',
    padding: '12px 8px',
    border: '1px solid #A1A1A1',
    borderRadius: '5px',
  },
  inputItem: {
    display: 'flex',
    gap: '5px',
  },
  genderOtherInput: {
    marginLeft: '10px',
    display: 'flex',
  },
  genderContent: {
    fontSize: '12px',
  },
  heightWeightContainer: {
    display: 'flex',
    gap: '22px',
  },
  inputTextField: {
    borderRadius: '5px !important',
    backgroundColor: 'white !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    width: '100%',
  },
  itemsDescription: {
    fontSize: '11px',
    fontStyle: 'italic',
    color: '#838383',
  },
  inputContentItem: {
    width: '81%',
  },
  inputContentOtherItem: {
    width: '38%',
    marginLeft: '-32px',
  },
  insuredContent: {
    marginBottom: '15px',
    display: 'flex',
    gap: '31%',
  },
  subHeadingItem: {
    fontSize: '16px',
    color: 'black',
    marginLeft: '5px',
    fontWeight: '600',
  },
  styleContent: {
    fontSize: '12px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '4% 0% 4% 0%',
  },
  almostImage: {
    display: 'flex',
    border: '1px solid #DDDDDD',
    borderRadius: '10px 0px 0px 10px',
    padding: '15px 25px 15px 25px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  almostImageContent: {
    display: 'flex',
  },
  almostContent: {
    fontSize: '16px',
    marginLeft: '6px',
    fontWeight: '600',
  },
  almostDescription: {
    fontSize: '16px',
    color: '#EF669B',
    marginLeft: '5px',
    fontWeight: '600',
  },
  healthDetailsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'linear-gradient(228.98deg, #4EC4E4 9.13%, #0288AC 167.68%)',
    border: '1px solid #DDDDDD',
    borderRadius: '0px 10px 10px 0px',
    padding: '9px 25px 6px 25px',
  },
  healthDetailDescription: {
    fontSize: '16px  !important',
    marginRight: '6px  !important',
    border: '1px  !important',
    cursor: 'pointer  !important',
    color: 'white !important',
    textTransform: 'unset !important',
    fontWeight: '600 !important',
  },
  goBackButtonContainer: {
    display: 'flex',
    cursor: 'pointer',
    gap: '5px',
    marginBottom: '10px',
  },
  emptyField: {
    border: '1px solid red !important',
  },

  nomineeContainer: {
    display: 'flex',
    alignItems: 'stretch',
    gap: '7px',
  },
  infoIcon: {
    cursor: 'pointer',
  },
  formContainerStyles: {
    margin: 0,
  },
})
